
import React, { Component } from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import isArray from 'lodash/isArray';
import get from 'lodash/get';

import {
    ButtonCommandSetCenter,
    MapInContainer,
    getLayerIdFromFeature, getLayerIdFromFeatureForData
} from '../../map';
import { MultiScene } from '../../multiscene';
import { getToolsMode } from '../../map';
import { getMapLayers } from '../../project';
import ButtonCommandClose from './ButtonCommandClose';

import { Log } from '../../core';
const log = Log.getLogger('MultiSceneForApp.mapmultiscene.MapMultiScene');

const CLASS_NAMES_MMS_POINT_LEFT = mergeStyleSets({
    root: {
        display: 'flex',
        height: '100%',
        flexDirection: 'row'
    },
    multiScene: {
        flexGrow: 1,
        flexBasis: '50%'
    },
    mapView: {
        flexGrow: 1,
        flexBasis: '50%'
    }
});

const CLASS_NAMES_MMS_POINT_RIGHT = mergeStyleSets({
    root: {
        display: 'flex',
        height: '100%',
        flexDirection: 'row-reverse'
    },
    multiScene: {
        flexGrow: 1,
        flexBasis: '50%'
    },
    mapView: {
        flexGrow: 1,
        flexBasis: '50%'
    }
});

const CLASS_NAMES_ONLY_MAP = mergeStyleSets({
    root: {
        display: 'flex',
        height: '100%'
    },
    multiScene: {
        flexGrow: 0,
        flexBasis: '0%'
    },
    mapView: {
        flexGrow: 1,
        flexBasis: '100%'
    }
});

class MapMultiScene extends Component {

    constructor(props) {
        super(props);
        this._multiSceneComponent = null;
        this._mapComponent = null;
        this._layerLook = null;
        this._lookParams = null;
    }

    componentDidMount() {
        this._lookParams = this.getLookParams();

        let olMap = this._mapComponent.getOlMap();

        this._layerLook = olMap.createLayer({
            id: 'mapmultiscene_look',
            type: 'Vector',
            style: this._lookParams.style
        });

        olMap.getMap().addLayer(this._layerLook);

        this._featureLook = olMap.createFeatureFromWkt('POINT(0 0)', {rotation: 0});
        this._layerLook.getSource().addFeature(this._featureLook);

        window.addEventListener('resize', this.handleResize);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.mapMultiScene.mmsPoint !== this.props.mapMultiScene.mmsPoint) {
            this._mapComponent.updateSize();
        }

        if (this.props.mapMultiScene.mmsPoint) {
            if (this._multiSceneComponent) {
                this._multiSceneComponent.updateSize();
            }
        } else {
            if (this._mapComponent) {
                let olMap = this._mapComponent.getOlMap();
                if (olMap) {
                    let geometry = olMap.createGeometryFromWkt('POINT(0 0)');
                    this._featureLook.setGeometry(geometry);
                }
            }
        }

        if (this.props.mapMultiScene.mmsPoint && this.props.multiScene.initialized) {
            if (
                (this.props.mapMultiScene.mmsPoint !== prevProps.mapMultiScene.mmsPoint) ||
                (this.props.multiScene.initialized !== prevProps.multiScene.initialized)
            ) {
                if (this._multiSceneComponent) {
                    let values = this.props.mapMultiScene.mmsPoint;
                    let hasPointYaw = (values.yaw !== undefined && values.yaw !== null);
                    let hasPointPitch = (values.pitch !== undefined && values.pitch !== null);
                    let yaw = (
                        hasPointYaw
                            ? values.yaw
                            : ((this.props.urlParams.yaw * Math.PI / 180) || 0)
                    );
                    let pitch = (
                        hasPointPitch
                            ? values.pitch
                            : ((this.props.urlParams.pitch * Math.PI / 180) || 0)
                    );
                    this._multiSceneComponent.showPositionOnTrajectory(
                        values.trj_name, values.photo_name, values.x, values.y, values.z,
                        yaw, pitch,
                        {
                            ...this._multiSceneComponent.getModeParams(this.props.multiScene.mode)
                        }
                    );
                }
            }
        }
    }

    createLookPolygonWkt(x, y, angle) {
        let sides = this._lookParams.sides;
        let radius = this._lookParams.radius;
        let lookAngle2 = this._lookParams.lookAngle2 * Math.PI / 180;
        let angleStart = angle - lookAngle2 + (Math.PI / 2);
        let angleStep = (lookAngle2 * 2) / sides;
        let points = [[x, y]];
        for (let i = 0; i < (sides + 1); ++i) {
            let rotatedAngle = angleStart + (i * angleStep);
            let x1 = x + (radius * Math.cos(rotatedAngle));
            let y1 = y + (radius * Math.sin(rotatedAngle));
            points.push([x1, y1]);
        }
        points.push([x, y]);
        let wkt = `POLYGON((${points.map(item => {return item[0] + ' ' + item[1]})}))`;
        return wkt;
    }

    getLookParams() {
        const DEFAULT_LOOK_PARAMS = {
            sides: 8,
            radius: 20,
            lookAngle2: 45,
            style: {
                default: {
                    type: 'polygon',
                    color: 'rgba(0, 0, 255, 0.5)',
                    width: 0,
                    outlineColor: 'rgba(0, 0, 0, 0)'
                }
            }
        };

        const appLookParams = get(this.props.appConfig, 'mapmultiscene.lookParams', {});

        const params = {
            ...DEFAULT_LOOK_PARAMS,
            ...appLookParams
        };

        return params;
    }

    handleCameraChange = (params) => {
        this.props.mapMultiSceneActions.setCameraParams(params);

        if (this._mapComponent) {
            let olMap = this._mapComponent.getOlMap();

            let wkt = this.createLookPolygonWkt(
                params.cameraPosition.x,
                params.cameraPosition.y,
                params.cameraRotation.yaw
            )

            let geometry = olMap.createGeometryFromWkt(wkt);
            this._featureLook.setGeometry(geometry);
        }
    }

    handleChangeView = (center, zoom, rotation, resolution) => {
        if (this.props.onChangeView) {
            this.props.onChangeView(center, zoom, rotation, resolution);
        }
    }

    handleFeatureClick = (feature) => {
        if (this.isLayerMmsPoint(getLayerIdFromFeature(feature))) {
            this.setMmsPoint(feature.getProperties());
        } else {
            let layerId = getLayerIdFromFeatureForData(feature);
            if (layerId) {
                this.showObjectInfo(layerId, feature.getProperties());
            }
        }
    }

    handleFeaturesFind = (features, finished, coordinates) => {
        let objects = features.map(item => {
            return {
                layerId: getLayerIdFromFeatureForData(item),
                attributes: item.getProperties()
            }
        });
        if (this.props.onObjectsInfo) {
            this.props.onObjectsInfo(objects, finished, coordinates);
        }
    }

    handleMultiSceneObjectInfo = (layerId, attributes) => {
        if (this.isLayerMmsPoint(layerId)) {
            this.setMmsPoint(attributes);
         } else {
            this.showObjectInfo(layerId, attributes);
        }
    }

    handleShowMessage = (message) => {
        if (this.props.onShowMessage) {
            this.props.onShowMessage(message);
        }
    }

    handleResize = (event) => {
        setTimeout(
            () => {
                // Hack: set manual width, and auto resize is call automaticaly
                if (this._multiSceneComponent) {
                    this._multiSceneComponent.updateSize(100, null);
                }
            },
            100
        );
    }

    handleSetLayerVisibility = (id, visible) => {
        this.props.mapActions.setLayerVisibility(id, visible);
    }

    isLayerMmsPoint(layerId) {
        let flag = false;
        if (layerId && this.props.multiSceneProject && isArray(this.props.multiSceneProject.mmsPointLayers)) {
            flag = this.props.multiSceneProject.mmsPointLayers.reduce((previous, current) => {
                return layerId.endsWith(current)
                    ? true
                    : previous;
            }, false);
        }
        return flag;
    }

    render() {
        return (this.props.multiSceneProject && this.props.map.definition)
            ? this.renderForProject()
            : null;
    }

    renderForProject() {
        const multiSceneVisible = !!this.props.mapMultiScene.mmsPoint;

        let classNames = (multiSceneVisible)
            ? (this.props.layoutValues && (this.props.layoutValues['multiScenePanelPosition'] === 'right'))
                ? CLASS_NAMES_MMS_POINT_RIGHT
                : CLASS_NAMES_MMS_POINT_LEFT
            :CLASS_NAMES_ONLY_MAP;

        const multiSceneComponent = this.renderMultiScene();
        const mapComponent = this.renderMapComponent();

        return (
            <div className={classNames.root}>
                <div className={classNames.multiScene}>
                    {multiSceneVisible && multiSceneComponent}
                </div>
                <div className={classNames.mapView}>
                    {mapComponent}
                </div>
            </div>
        );
    }

    renderMapComponent() {
        const toolsMode = getToolsMode(this.props.map);

        return (
            <MapInContainer
                ref={element => this._mapComponent = element}
                appConfig={this.props.appConfig}
                map={this.props.map}
                mapLayersDefinition={getMapLayers(this.props.project)}
                appActions={this.props.appActions}
                mapActions={this.props.mapActions}
                measurementActions={this.props.measurementActions}
                toolsMode={toolsMode}
                onChangeView={this.handleChangeView}
                onFeatureClick={this.handleFeatureClick}
                onFeaturesFind={this.handleFeaturesFind}
                onShowMessage={this.handleShowMessage}
            />
        );
    }

    renderMultiScene() {
        const buttonsBefore = [
            <ButtonCommandSetCenter
                x={this.props.mapMultiScene.cameraParams
                    ? this.props.mapMultiScene.cameraParams.cameraPosition.x
                    : null
                }
                y={this.props.mapMultiScene.cameraParams
                    ? this.props.mapMultiScene.cameraParams.cameraPosition.y
                    : null
                }
            />,
            <ButtonCommandClose/>
        ];

        const toolsMode = getToolsMode(this.props.map);
        const modes = this.props.layoutValues.useStandaloneScene ? [] : null;
        const disableMeasure = this.props.layoutValues.useStandaloneScene
            ? (this.props.multiScene.mode === 'pano') ? true : false
            : false;

        return (
            <MultiScene
                ref={element => {this._multiSceneComponent = element}}
                appConfig={this.props.appConfig}
                projectUrl={this.props.multiSceneProject.url}
                initialized={this.props.multiScene.initialized}
                mode={this.props.multiScene.mode}
                modes={modes}
                initialMode="pano"
                commands={this.props.multiScene.commands}
                layers={this.props.map.layers}
                appActions={this.props.appActions}
                multiSceneActions={this.props.multiSceneActions}
                measurementActions={this.props.measurementActions}
                showHomeScene={false}
                buttonsBefore={buttonsBefore}
                disableMeasure={disableMeasure}
                toolsMode={toolsMode}
                onCameraChange={this.handleCameraChange}
                onObjectInfo={this.handleMultiSceneObjectInfo}
            />
        );
    }

    setMmsPoint = (attributes) => {
        this.props.mapMultiSceneActions.setMmsPoint(attributes);
    }

    showObjectInfo = (layerId, attributes) => {
        if (this.props.onObjectInfo) {
            this.props.onObjectInfo(layerId, attributes);
        }
    }
}

export default MapMultiScene;
